var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "map_svg__svg-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 31.25a2.407 2.407 0 0 1-1.766-.734 2.407 2.407 0 0 1-.734-1.766v-12.5c0-.688.245-1.276.734-1.766a2.407 2.407 0 0 1 1.766-.734h2.5v-2.5c0-.688.245-1.276.734-1.766a2.407 2.407 0 0 1 1.766-.734h7.5c.688 0 1.276.245 1.766.734.49.49.734 1.079.734 1.766v7.5h2.5c.688 0 1.276.245 1.766.734.49.49.734 1.078.734 1.766v7.5c0 .688-.245 1.276-.734 1.766-.49.49-1.078.734-1.766.734h-7.5v-5h-2.5v5h-7.5Zm0-2.5h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm5 5h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm5 10h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Zm5 15h2.5v-2.5h-2.5v2.5Zm0-5h2.5v-2.5h-2.5v2.5Z",
    fill: "currentColor"
  })));
};
export { SvgMap as ReactComponent };